module.exports = __webpack_public_path__ + "static/media/shape3_3.9d26c2b2.obj";